---
title: "Healthcare Video Series"
seo:
  title: "Healthcare Video Series | Gage Technologies"
  description: "Greg Hatch of Gage Technologies on where healthcare communication breaks down and how to fix it. Watch the eight-part video series."
---

<VSHero
  label="Executive Series"
  title="Rethinking Healthcare Communication"
  description="In healthcare, every interaction shapes the patient experience. From scheduling and care coordination to billing, follow-up, and compliance, communication breakdowns create friction for patients, providers, and the teams working behind the scenes."
  buttonText="Watch Series"
  buttonHref="#series"
  imageSrc="/img/section-images/healthcare-hero.webp"
  imageAlt="Abstract network lines"
/>

<VSFeaturedVideo
  partLabel="Part 1"
  title="Broken patient journeys"
  duration="< 1 MIN"
  youtubeId="HsLfZfy0pT4"
/>

<VSOverview
  title="About the Series"
  description="In this short video series, Greg Hatch of Gage Technologies explores how healthcare leaders can rethink communication, collaboration, AI, and compliance as connected parts of a better patient journey."
  topics={[
    "Where communication breaks down across the patient experience",
    "Why navigating care is still too difficult for many patients",
    "How AI and automation can reduce administrative burden without removing the human side of care",
    "Why compliance and patient experience should be designed together",
    "What it takes to modernize legacy systems without disrupting care delivery",
    "How better collaboration can improve outcomes for patients, providers, and healthcare organizations"
  ]}
  footerText="Healthcare leaders have to do more than modernize technology. They also have to simplify complexity, protect trust, reduce friction, and create better experiences for the people they serve."
  footerText2="Watch the series and see what better healthcare communication looks like in practice."
>
  <VSVideoGrid>
    <VSVideoCard
      part="Part 1"
      title="Broken patient journeys"
      duration="0:49"
      youtubeId="HsLfZfy0pT4"
    />
    <VSVideoCard
      part="Part 2"
      title="Navigating care"
      duration="0:53"
      youtubeId="iXL5kIqk_vU"
    />
    <VSVideoCard
      part="Part 3"
      title="Automation with humanity"
      duration="0:52"
      youtubeId="wWohmKHJ294"
    />
    <VSVideoCard
      part="Part 4"
      title="AI beyond the hype"
      duration="1:16"
      youtubeId="N0cJhhDu2CQ"
    />
    <VSVideoCard
      part="Part 5"
      title="Designing better care journeys"
      duration="1:23"
      youtubeId="18zFZ9I7sTs"
    />
    <VSVideoCard
      part="Part 6"
      title="Breaking collaboration barriers"
      duration="0:51"
      youtubeId="N2z5lL5EoNw"
    />
    <VSVideoCard
      part="Part 7"
      title="Measuring patient experience"
      duration="1:15"
      youtubeId="gB19ZED0D_4"
    />
    <VSVideoCard
      part="Part 8"
      title="Compliance and patient trust"
      duration="1:15"
      youtubeId="U3_QauYLxRk"
    />
  </VSVideoGrid>
</VSOverview>